import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.menu;

export const menuSelectors = {
  menusInCart: createSelector(selector, (state) => state.menusInCart),
  menusToReorder: createSelector(selector, (state) => state.menusToReorder),
};
